
export class TabUtils {
    public static roll<T>(arr: T[], offset: number): T[] {

        const len = arr.length;
        if (len === 0) 
            return arr;

        const normalizedShift = ((offset % len) + len) % len;

        return arr.slice(normalizedShift).concat(arr.slice(0, normalizedShift));
    }
}